<template>
    <div>
        <div class="row">
            <div class="col-lg-4">
                <b-card no-body class="p-1">
                    <div class="row">
                        <div class="col-12 mb-1">
                            <b-form-checkbox v-model="remember">Seçimleri Hatırla <br/><small>(Kasa, Gelir/Gider, Banka Efektif Tarihi, Proje Kodu)</small></b-form-checkbox>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Kasa</label>
                            <v-validator :errors="errors" parameter="VaultCode" :watch="kasa">
                                <v-select-list   v-model="kasa" v-on:input="getKasaDovizDeger" :options="kasaList" label="KSMAS_NAME" placeholder="Kasa" :loading="kasaLoading"></v-select-list>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Gelir/Gider</label>
                            <v-validator :errors="errors" parameter="VaultActionType" :watch="gcType">
                                <v-select-list v-model="gcType" label="Name" v-on:input="getKasaHareketToday" :options="gcTypes" placeholder="Gelir/Gider" ></v-select-list>
                            </v-validator>
                        </div>
                        <div class="col-12">
                            <div class="mb-1" v-if="pleaseWait">
                                <span class="text-success">Döviz bilgileri getiriliyor. Lütfen Bekleyiniz... </span>
                            </div>
                            <v-validator :errors="errors" parameter="CurrencyRate" :watch="model.CurrencyRate">
                                <div class="table-responsive" v-if="currencyRateObj != null && !pleaseWait && currencyRateObj.CurrencyType && model.CurrencyType != null">
                                    <table class="table table-sm table-bordered mb-0" width="100%">
                                        <tbody>
                                            <tr>
                                                <th>Döviz Alış</th>
                                                <td>
                                                    <b-form-radio :value="currencyRateObj.DovizAlis" v-model="model.CurrencyRate" inline>
                                                        {{ currencyRateObj.DovizAlisStr }}
                                                    </b-form-radio>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Döviz Satış</th>
                                                <td>
                                                    <b-form-radio :value="currencyRateObj.DovizSatis" v-model="model.CurrencyRate" inline>
                                                        {{ currencyRateObj.DovizSatisStr }}
                                                    </b-form-radio>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Döviz Ef. Alış</th>
                                                <td>
                                                    <b-form-radio :value="currencyRateObj.EffAlis" v-model="model.CurrencyRate" inline>
                                                        {{ currencyRateObj.EffAlisStr }}
                                                    </b-form-radio>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Döviz Ef. Satış</th>
                                                <td>
                                                    <b-form-radio :value="currencyRateObj.EffSatis" v-model="model.CurrencyRate" inline>
                                                        {{ currencyRateObj.EffSatisStr }}
                                                    </b-form-radio>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1" v-if="model.CurrencyType != null && model.CurrencyType != 0">
                            <label class="form-label" >Döviz Tutar</label>
                            <v-validator :errors="errors" parameter="CurrencyAmount" :watch="model.CurrencyAmount">
                                <v-currency-input  v-on:input="calculateValue" input-class="text-right" :value="model.CurrencyAmount" v-on:update-value="currencyAmount => model.CurrencyAmount = currencyAmount"></v-currency-input>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1" v-if="model.CurrencyType == 0 || model.CurrencyType == null">
                            <label class="form-label" >Tutar</label>
                            <v-validator :errors="errors" parameter="Amount" :watch="model.Amount">
                                <v-currency-input  input-class="text-right" :value="model.Amount" v-on:update-value="amount => model.Amount = amount"></v-currency-input>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Banka Hesabı</label>
                            <v-validator :errors="errors" parameter="BankAccountCode" :watch="bank">
                                <v-select-list :disabled="!bankEnabled" v-model="bank" :options="bankList" label="Information" placeholder="Banka Hesabı" :loading="bankLoading"></v-select-list>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Proje Kodu</label>
                            <v-validator :errors="errors" parameter="ProjectCode" :watch="projectCode">
                                <v-select-list v-model="projectCode" :options="projectCodes" label="label" placeholder="Proje Kodu" ></v-select-list>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Banka Efektif Tarihi</label>
                            <v-validator :errors="errors" parameter="EffectiveDate" :watch="model.EffectiveDate">
                                <v-date-picker v-model="model.EffectiveDate" placeholder="Banka Efektif Tarihi"/>
                            </v-validator>
                        </div>
                        <!-- <div class="col-12 mb-1">
                            <label class="form-label">Plasiyer</label>
                            <v-validator :errors="errors" parameter="PlasiyerCode" :watch="plasiyerCode">
                                <v-select-list v-model="plasiyerCode" :loading="plasiyerLoading"  label="PlasiyerInformation" :options="plasiyerList" placeholder="Plasiyer" ></v-select-list>
                            </v-validator>
                        </div> -->
                        <div class="col-12 mb-1">
                            <label class="form-label">Kasa Rapor Kodu</label>
                            <v-validator :errors="errors" parameter="KasaRapor_Kodu" :watch="reportCode">
                                <v-select-list v-model="reportCode" :options="reportCodes" label="Code" placeholder="Kasa Rapor Kodu" ></v-select-list>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Kasa Açıklaması</label>
                            <v-validator :errors="errors" parameter="VaultDescription" :watch="model.VaultDescription">
                                <textarea class="form-control resize-none" rows="2" maxlength="100" placeholder="Kasa Açıklaması" v-model="model.VaultDescription"></textarea>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">TMS Kasa Açıklaması</label>
                            <v-validator :errors="errors" parameter="TMSVaultDescription" :watch="model.TMSVaultDescription">
                                <textarea class="form-control resize-none" rows="2" maxlength="100" placeholder="Kasa Açıklaması" v-model="model.TMSVaultDescription"></textarea>
                            </v-validator>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Banka Açıklaması</label>
                            <textarea class="form-control resize-none" rows="2" maxlength="100" placeholder="Banka Açıklaması" v-model="model.BankDescription"></textarea>
                        </div>
                        <div class="col-12 mb-1">
                            <label class="form-label">Yevmiye Açıklaması</label>
                            <textarea class="form-control resize-none" rows="2" maxlength="100" placeholder="Yevmiye Açıklaması" v-model="model.WageDescription"></textarea>
                        </div>
                        <div class="col-md-12 text-right">
                            <v-executer :loading="saveLoading" :action="save"> Kaydet </v-executer>
                        </div>
                    </div>
                </b-card>
            </div>
            <div class="col-lg-8">
                <b-card no-body>
                    <v-table    ref="table"
                                name="vault-actions"
                                with-items
                                :settings="false"
                                :fields="fields"
                                :buttons="buttons"
                                search
                                :items="kasaHareketToday">
                            <template #additional-actions>
                                <h4 class="mb-0">Bugünkü Hareketler</h4>
                            </template>
                            </v-table>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
import { BCard,BFormInput,BFormRadio,BOverlay,BFormCheckbox } from 'bootstrap-vue'
import NetsisOperationsApi from '@/api/netsis-operations'
import VCurrencyInput from '@/components/VCurrencyInput.vue'
import VExecuter from '@/components/VExecuter.vue'
import moment from 'moment'
import { printFis } from '../components/fis/print-fis';
import { printTediyeFis } from '../components/fis/print-tediye-fis'

export default {
    components:{
        BCard,
        BFormRadio,
        VCurrencyInput,
        BFormInput,
        VExecuter,
        BOverlay,
        BFormCheckbox
    },
    data(){
        return{
            remember:false,
            saveLoading:false,
            bankList:[],
            bankLoading:false,
            searchOnTableTimer:null,
            projectCodes:[
                {value:'R',label:'Banka 1'},
                {value:'G',label:'Banka 2'},
            ],
            gcTypes:[{Name:'Gelir',Value:'G'},{Name:'Gider',Value:'C'}],
            fields:[
                { name:'Kasa Kodu',key:'KSMAS_KOD', tdClass:'text-nowrap',thClass:'w-6'},
                { name:'Kasa Adı',key:'KSMAS_NAME',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Tarih',key:'TARIHStr',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Zaman',key:'ZAMAN',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'G/Ç',key:'IO',thClass:'w-7', tdClass:'text-nowrap'},
                { name:'Fiş No',key:'FIS_NO',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Tip',key:'TIP',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Açıklama',key:'ACIKLAMA',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'TMS Açıklama',key:'TMSVaultDescription',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Tutar',key:'TUTAR', tdClass:'text-nowrap text-right',thClass:'w-7', tdClass:'text-nowrap text-right'},
                { name:'Cari/Muh',key:'CARI_MUH', tdClass:'text-nowrap',thClass:'w-7'},
                { name:'Kod',key:'KOD',thClass:'w-7', tdClass:'text-nowrap', tdClass:'text-nowrap'},
                { name:'Cari Adı',key:'CARI_ISIM',thClass:'w-7', tdClass:'text-nowrap '},
                { name:'Muh. Adı', key:'MUH_ADI', tdClass:'text-nowrap',thClass:'w-7'},
                { name:'Plasiyer Adı',key:'PLASIYER_ISIM',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Şube Adı',key:'SUBE_ADI', tdClass:'text-nowrap',thClass:'w-16'},
            ],
            model:{
                BankAccountCode:null,
                BankAccountName:null,
                CurrencyAmount:0,
                Amount:0,
                VaultDescription: null,
                TMSVaultDescription: null,
                EffectiveDate:moment().format('YYYY-MM-DD'),
                BankDescription:"nakit Çekilen",
                PlasiyerCode:null,
                PlasiyerName:null,
                ProjectCode:null,
                VaultActionType:"G",
                VaultCode:null,
                VaultName:null,
                CurrencyType:null,
                IsCurrency:null,
                CurrencyRate:null,
                WageDescription:null,
                KasaRapor_Kodu:null
            },
            fields:[
                { name:'Kasa Kodu',key:'KSMAS_KOD', tdClass:'text-nowrap',thClass:'w-6'},
                { name:'Kasa Adı',key:'KSMAS_NAME',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Tarih',key:'TARIHStr',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Zaman',key:'ZAMAN',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'G/Ç',key:'IO',thClass:'w-7', tdClass:'text-nowrap'},
                { name:'Fiş No',key:'FIS_NO',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Tip',key:'TIP',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Açıklama',key:'ACIKLAMA',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Tutar',key:'TUTAR', tdClass:'text-nowrap text-right',thClass:'w-7', tdClass:'text-nowrap text-right'},
                { name:'Cari/Muh',key:'CARI_MUH', tdClass:'text-nowrap',thClass:'w-7'},
                { name:'Kod',key:'KOD',thClass:'w-7', tdClass:'text-nowrap', tdClass:'text-nowrap'},
                { name:'Cari Adı',key:'CARI_ISIM',thClass:'w-7', tdClass:'text-nowrap '},
                { name:'Muh. Adı', key:'MUH_ADI', tdClass:'text-nowrap',thClass:'w-7'},
                { name:'Plasiyer Adı',key:'PLASIYER_ISIM',thClass:'w-6', tdClass:'text-nowrap'},
                { name:'Şube Adı',key:'SUBE_ADI', tdClass:'text-nowrap',thClass:'w-16'},
            ],
            buttons:[
                { text:"Fiş Yazdır",key:"fis",icon:"PrinterIcon",variant:"primary",action:this.print, },
                { text:"Yevmiye Fişi Yazdır",key:"ted-fis",icon:"PrinterIcon",variant:"secondary",action:this.printTediye },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.deleteHareket },
            ],
            errors:{},
            pleaseWait: false,
            plasiyerLoading:false,
            kasaLoading:false,
            plasiyerList:[],
            kasaList:[],
            currencyRateObj:{
                CurrencyType:null,
                Date:null,
                DovizAlis:null,
                DovizSatis:null,
                EffAlis:null,
                EffSatis:null,
                DovizAliStr:null,
                DovizSatisStr:null,
                EffAlisStr:null,
                EffSatisStr:null,
            },
            calculatedValue:0,
            kasaHareketToday:[],
            bankEnabled:false,
            rapor:[],
            reportCodes:[]
        }
    },
    watch:{
        kasa(){
            this.checkDecs()
        },
        "model.VaultActionType"(){
            this.checkDecs(true)
        }
    },
    mounted(){
        this.getKasaList()
        this.getPlasiyerList()
        this.getReportCodes()
        this.getKasaHareketToday()
    },
    methods:{
        getReportCodes(){
            NetsisOperationsApi.ReportCode.List().then(res => {
                if(res.data.Success){
                    this.reportCodes = res.data.Data || []
                }
            })
        },
        checkDecs(force){
            if(force){
                this.model.BankDescription = this.model.VaultActionType == "C" ? "nakit Yatırılan" : "nakit Çekilen"
            }
            if(this.model.BankDescription?.startsWith('nakit Yatırılan') || this.model.BankDescription?.startsWith("nakit Çekilen")){
                this.model.BankDescription = [
                    this.model.VaultActionType == "C" ? "nakit Yatırılan" : "nakit Çekilen",
                    this.kasa != null ? `(${this.kasa.KSMAS_KOD})` : null
                ].filter(c => c).join(' ')
            }
        },
        printTediye(i){
            if(i.FIS_NO && i.TIP && i.SIRA){
                this.$refs.table.rowLoading(true)
                NetsisOperationsApi.TediyeFis(i.FIS_NO,i.TIP,i.SIRA).then(res => {
                    this.$refs.table.rowLoading(false)
                    if(res.data.Success){
                        printTediyeFis(res.data.Data)
                    }else{
                        this.$result(res)
                    }
                }).catch(err => {
                    this.$refs.table.rowLoading(false)
                    this.$result(null,err)
                })
            }
        },
        getKasaHareketToday(){
            this.$refs.table.setLoading(true)
            NetsisOperationsApi.GetBankaKasaHareketToday().then((res)=>{
                this.kasaHareketToday = res.data.Data
                this.$refs.table.setLoading(false)
            }).catch(err=> {
                this.$refs.table.setLoading(false)
                console.log(err)
            })
        },
        clearForm(){
            if(!this.remember){
                this.model.VaultActionType="G"
                this.model.VaultCode=null
                this.model.VaultName=null
                this.model.EffectiveDate=moment().format('YYYY-MM-DD')
                this.model.ProjectCode=null
            }
            this.model.BankAccountCode=null
            this.model.BankAccountName=null
            this.model.CurrencyAmount=0
            this.model.Amount=0
            this.model.VaultDescription= null
            this.model.TMSVaultDescription= null
            this.model.WageDescription= null
            this.model.CHDescription="nakit Çekilen"
            this.model.PlasiyerCode=null
            this.model.PlasiyerName=null
            this.model.CurrencyType=null
            this.model.IsCurrency=null
            this.model.CurrencyRate=null
            this.model.KasaRapor_Kodu=null
        },
        save(){
            this.saveLoading=true
            NetsisOperationsApi.SaveBankKasaHareket(this.model).then((res)=>{
                this.$result(res)
                this.saveLoading=false
                if(res.data.Success){
                    this.clearForm()
                    this.print({FIS_NO:res.data.Data})
                    this.getKasaHareketToday()
                }
            }).catch(err=> {
                this.saveLoading=false
                this.$result(null,err)
            })
        },
        calculateValue(){
            this.calculatedValue= this.currencyRateObj.Rate * this.model.Amount
        },
        getKasaDovizDeger(){
            this.getKasaHareketToday()
            this.pleaseWait=true
            this.bankEnabled = false
            this.model.CurrencyType = this.model.CurrencyType == null ? 0 : this.model.CurrencyType
            NetsisOperationsApi.GetNetsisCurrencyData(this.model.CurrencyType).then((res) => {
                this.getBankList(this.model.CurrencyType)
                if(res.data.Data != null){
                    this.currencyRateObj = res.data.Data
                }else{
                    this.currencyRateObj = null
                }
                this.pleaseWait=false
            }).catch(err=> {
                console.log(err)
            })
        },
        getKasaList(){
            this.kasaLoading = true
            NetsisOperationsApi.GetKasaList().then(res => {
                this.kasaList = res.data.Data
                this.kasaLoading = false
            }).catch(err=> {
                console.log(err)
                this.kasaLoading = false
            })
        },
        getBankList(model){
            this.bankLoading = true
            this.bankList = []
            NetsisOperationsApi.GetBankList(model).then((res) => {
                this.bankList = res.data.Data
                this.bankLoading = false
                this.bankEnabled = true
            }).catch(err=> {
                console.log(err)
                this.bankLoading = false
            })
            
        },
        getPlasiyerList(){
            this.plasiyerLoading = true
            NetsisOperationsApi.GetPlasiyerList().then((res) => {
                this.plasiyerList = res.data.Data
                this.plasiyerLoading = false
            }).catch(err=> {
                console.log(err)
                this.plasiyerLoading = false
            })
        },
        deleteHareket(i){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${i.SIRA} sıra numaralı işlemi silecektir ve geri alınamaz.`)
            .then(c => {
                if(c){
                    NetsisOperationsApi.DeleteKasaHareket(i.SIRA).then(res => {
                        this.$result(res)
                        if(res.data.Success){
                            this.$refs.table.refresh()
                        }
                    })
                }
            }).catch(err => {
                this.$result(null,err)
            })
        },
        print(i){
            if(i.FIS_NO){
                this.$refs.table.rowLoading(true)
                NetsisOperationsApi.BankaFis(i.FIS_NO,i.SIRA).then(res => {
                    this.$refs.table.rowLoading(false)
                    if(res.data.Success){
                        printFis(res.data.Data)
                    }else{
                        this.$result(res)
                    }
                }).catch(err => {
                    this.$refs.table.rowLoading(false)
                    this.$result(null,err)
                })
            }
        },
    },
    computed:{
        bank:{
            get:function(){
                return this.bankList.find(s=>s.NETHESKODU==this.model.BankAccountCode)
            },
            set:function(value){
                this.model.BankAccountCode= value?.NETHESKODU || null
                this.model.VaultDescription = value?.ACIKLAMA||null
                this.model.WageDescription = value?.ACIKLAMA||null
                this.model.BankAccountName = value?.ACIKLAMA||null
            }
        },
        gcType:{
            get:function(){
                return this.gcTypes.find(s=>s.Value==this.model.VaultActionType)
            },
            set:function(value){
                this.model.VaultActionType = value?.Value || null
            }
        },
        plasiyerCode:{
            get:function(){
                return this.plasiyerList.find(s=>s.PlasiyerCode==this.model.PlasiyerCode)
            },
            set:function(value){
                this.model.PlasiyerCode = value?.PlasiyerCode || null
                this.model.PlasiyerName = value?.PlasiyerName || null
            }
        },
        kasa:{
            get:function(){
                return this.kasaList.find(s=>s.KSMAS_KOD==this.model.VaultCode)
            },
            set:function(value){
                this.model.VaultCode = value?.KSMAS_KOD || null
                this.model.VaultName = value?.KSMAS_NAME || null
                this.model.CurrencyType = value?.DOVIZTIPI || null
                this.model.IsCurrency = value?.DOVIZLI || null
            }
        },
        reportCode:{
            get:function(){
                return this.reportCodes.find(s=>s.Code==this.model.KasaRapor_Kodu)
            },
            set:function(value){
                this.model.KasaRapor_Kodu = value?.Code || null
            }
            
        },
        projectCode:{
            get:function(){
                return this.projectCodes.find(s=>s.value==this.model.ProjectCode)
            },
            set:function(value){
                this.model.ProjectCode = value?.value || null
            }
        }
    }
}
</script>